(function () {
  'use strict';

  angular
      .module('tfc.Toast')
      .controller('ToastCtrl', ToastCtrl)
      .directive('tfcToast', tfcToast);

  // @ngInject
  function ToastCtrl($scope, Toast) {
    var vm = this;
    $scope.$watchCollection(Toast.list, function (messages) {
      vm.messages = messages;
    });
    vm.dismiss = Toast.dismiss;
    vm.translate = Toast.translate;
  }

  // @ngInject
  function tfcToast() {
    return {
      controller : 'ToastCtrl as vm',
      scope : {},
      templateUrl : 'Toast/Toast.tmpl.html'
    };
  }

})();
